<section class="faq" data-testid="faq-section">
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="xl">
    Frequently asked questions
  </goab-text>

  <goab-button
    type="tertiary"
    size="compact"
    mt="none"
    mb="m"
    (onClick)="onToggleAccordion()"
  >
    {{ accordionStatus }}
  </goab-button>

  @for (section of sections; track section.title; let sectionIndex = $index) {
  <goab-accordion
    headingSize="medium"
    [heading]="section.title"
    [open]="expandedList[sectionIndex]"
    (onChange)="toggleAccordion(sectionIndex, $event)"
    [attr.data-testid]="'faq-accordion-' + sectionIndex"
    mb="s"
  >
    <div class="faq__accordion-content">
      @for (item of section.items; track item.question) {
      <goab-spacer vSpacing="s"></goab-spacer>
      <goab-text tag="h2" size="body-m" mt="xs" mb="s">
        <strong>{{ item.question }}</strong>
      </goab-text>
      @for (answer of item.answers; track answer; let isLastAnswer = $last) {
      <goab-text tag="span" size="body-m" mt="none" mb="none">
        {{ answer }}
      </goab-text>
      @if (!isLastAnswer) {
      <goab-spacer vSpacing="m"></goab-spacer>
      } } @if (item.bulletPoints && item.bulletPoints.length > 0) {
      <ul class="faq__bullet-list">
        @for (bullet of item.bulletPoints; track bullet) {
        <li>
          <goab-text tag="span" size="body-m" mt="none" mb="none">
            {{ bullet }}
          </goab-text>
        </li>
        }
      </ul>
      } }
    </div>
  </goab-accordion>
  }

  <goab-spacer vSpacing="3xl"></goab-spacer>
</section>
